import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { MediaImage } from '@sirius/common';
import { BundleItem, manufacturer } from 'commerce/models';

@Component({
    selector: 'commerce-bundle-item',
    templateUrl: './bundle-item.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./bundle-item.component.scss']
})
export class BundleItemComponent implements OnInit {
    @Input()
    config?: BundleItem;

    @Input()
    image?: MediaImage;

    productId = '';
    manufacturer?: manufacturer;
    title = '';
    sku?: string;
    link?: string;

    ngOnInit(): void {
        if (this.config?.product.image) {
            const newImage = new MediaImage(this.config.product.image, this.config.product.title);

            this.image = newImage;
        }

        if (this.config) {
            this.productId = this.config.product.productId;
            this.manufacturer = this.config.product.manufacturer;
            this.title = this.config.product.title;
            this.sku = this.config.product.sku;
            this.link = this.config.product.link;
        }
    }
}
